export default {
  currentPageTitle(state) {
    return state.currentMenu.title;
  },
  currentActiveMenu(state) {
    return state.currentMenu.url;
  },
  userType(state) {
    return state.userInfo.type;
  },
};



// WEBPACK FOOTER //
// ./src/store/getters.js